exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vpage__container {\n  padding: 32px;\n  background-color: #fff;\n}\n.vpage__container.vpage__container--borderless {\n  padding: 0px;\n}\n.vpage__container.vpage__container--borderless .vpage__header {\n  margin-bottom: 0;\n}\n.vpage__header {\n  margin-bottom: 52px;\n}\n", ""]);

// exports
